export default "__VITE_ASSET__Dk2SVp8B__"